module.exports = __webpack_public_path__ + "static/media/2-en.9d64e342.svg";